var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.663,
    height: 51.5,
    viewBox: "0 0 51.663 51.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27304",
    "data-name": "Group 27304",
    transform: "translate(8796.5 -9344.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30447",
    "data-name": "Path 30447",
    d: "M24.094-1.5a25.586,25.586,0,0,1,18.1,43.691A25.594,25.594,0,1,1,14.131.512,25.435,25.435,0,0,1,24.094-1.5Zm0,48.188A22.6,22.6,0,0,0,32.888,3.275,22.6,22.6,0,0,0,15.3,44.913,22.451,22.451,0,0,0,24.094,46.688Z",
    transform: "translate(-8794.525 9346.313)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30447-2",
    "data-name": "Path 30447",
    d: "M24.094-1.5a25.586,25.586,0,0,1,18.1,43.691A25.594,25.594,0,1,1,14.131.512,25.435,25.435,0,0,1,24.094-1.5Zm0,48.188A22.6,22.6,0,0,0,32.888,3.275,22.6,22.6,0,0,0,15.3,44.913,22.451,22.451,0,0,0,24.094,46.688Z",
    transform: "translate(-8795 9346)",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27231",
    "data-name": "Group 27231",
    transform: "translate(-771.185 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27200",
    "data-name": "Group 27200",
    transform: "translate(-8017.815 9364.982)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30396",
    "data-name": "Path 30396",
    d: "M78.08,22.416v3.55A2.1,2.1,0,0,0,80.2,28.035h3.094a4.787,4.787,0,0,0,9.51,0h6.806a4.787,4.787,0,0,0,9.51,0h4.066a1.136,1.136,0,0,0,1.184-1.086V23.226a1.136,1.136,0,0,0-1.184-1.086H94.661a1,1,0,0,1-.725-.207.357.357,0,0,1-.106-.276h0V11.4h0a1.2,1.2,0,0,0-1.167-.913H86.123a4.128,4.128,0,0,0-2.952,1.741,11.8,11.8,0,0,0-1.326,2.085,21.77,21.77,0,0,1-1.609,2.568l-.159.207a7.9,7.9,0,0,0-1.962,5.36ZM88.05,25.9a1.741,1.741,0,1,1-1.785,1.741A1.77,1.77,0,0,1,88.05,25.9ZM82.906,16.66s.088-.172.141-.259c.071-.1,1.29-2.172,1.768-2.844a2.708,2.708,0,0,1,2.333-1.4h3.535v6.5H82.517c-.159,0-.265,0-.3-.069-.177-.276.371-1.275.725-1.948Zm23.246,10.978a1.786,1.786,0,1,1-1.785-1.741A1.77,1.77,0,0,1,106.151,27.638Z",
    transform: "translate(-78.08 -8.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30397",
    "data-name": "Path 30397",
    d: "M99.749,17.784V14.089a.913.913,0,0,0-.919-.919h-5.02a.913.913,0,0,0-.919.919v3.695a.913.913,0,0,0,.919.919h5.02a.913.913,0,0,0,.919-.919Z",
    transform: "translate(-66.71 -6.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30398",
    "data-name": "Path 30398",
    d: "M95.039,17.784V14.089a.913.913,0,0,0-.919-.919H89.1a.913.913,0,0,0-.919.919v3.695a.913.913,0,0,0,.919.919h5.02a.913.913,0,0,0,.919-.919Z",
    transform: "translate(-70.326 -6.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30399",
    "data-name": "Path 30399",
    d: "M99.749,13.864V10.169a.913.913,0,0,0-.919-.919h-5.02a.913.913,0,0,0-.919.919v3.695a.913.913,0,0,0,.919.919h5.02a.913.913,0,0,0,.919-.919Z",
    transform: "translate(-66.71 -9.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30400",
    "data-name": "Path 30400",
    d: "M95.039,13.864V10.169a.913.913,0,0,0-.919-.919H89.1a.913.913,0,0,0-.919.919v3.695a.913.913,0,0,0,.919.919h5.02a.913.913,0,0,0,.919-.919Z",
    transform: "translate(-70.326 -9.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27201",
    "data-name": "Group 27201",
    transform: "translate(-8017.815 9364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30401",
    "data-name": "Path 30401",
    d: "M78.39,22.5v3.641a2.127,2.127,0,0,0,2.121,2.121H83.6a4.774,4.774,0,0,0,9.51,0h6.806a4.774,4.774,0,0,0,9.51,0H113.5a1.148,1.148,0,0,0,1.184-1.114V23.333A1.148,1.148,0,0,0,113.5,22.22H94.971a.986.986,0,0,1-.725-.212.373.373,0,0,1-.106-.283h0V11.207h0a1.2,1.2,0,0,0-1.167-.937H86.433a4.106,4.106,0,0,0-2.952,1.785,12.145,12.145,0,0,0-1.326,2.139,22.426,22.426,0,0,1-1.609,2.634l-.159.212a8.22,8.22,0,0,0-1.962,5.5Zm9.97,3.571a1.785,1.785,0,1,1-1.785,1.785A1.792,1.792,0,0,1,88.36,26.073ZM83.216,16.6s.088-.177.141-.265c.071-.106,1.29-2.227,1.768-2.917a2.7,2.7,0,0,1,2.333-1.432h3.535v6.664H82.827c-.159,0-.265,0-.3-.071-.177-.283.371-1.308.725-2Zm23.246,11.26a1.785,1.785,0,1,1-1.785-1.785A1.792,1.792,0,0,1,106.461,27.859Z",
    transform: "translate(-78.39 -8.078)",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30402",
    "data-name": "Path 30402",
    d: "M100.059,17.564V13.869a.913.913,0,0,0-.919-.919h-5.02a.913.913,0,0,0-.919.919v3.695a.913.913,0,0,0,.919.919h5.02a.913.913,0,0,0,.919-.919Z",
    transform: "translate(-67.02 -6.021)",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30403",
    "data-name": "Path 30403",
    d: "M95.339,17.564V13.869a.913.913,0,0,0-.919-.919H89.4a.913.913,0,0,0-.919.919v3.695a.913.913,0,0,0,.919.919h5.02a.913.913,0,0,0,.919-.919Z",
    transform: "translate(-70.644 -6.021)",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30404",
    "data-name": "Path 30404",
    d: "M100.059,13.644V9.949a.913.913,0,0,0-.919-.919h-5.02a.913.913,0,0,0-.919.919v3.695a.913.913,0,0,0,.919.919h5.02A.913.913,0,0,0,100.059,13.644Z",
    transform: "translate(-67.02 -9.03)",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30405",
    "data-name": "Path 30405",
    d: "M95.339,13.644V9.949a.913.913,0,0,0-.919-.919H89.4a.913.913,0,0,0-.919.919v3.695a.913.913,0,0,0,.919.919h5.02A.913.913,0,0,0,95.339,13.644Z",
    transform: "translate(-70.644 -9.03)",
    fill: "#FFAA00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.49d0b44b6cc07d2d7d2655a1a99dc828.svg";
export { ForwardRef as ReactComponent };